<template>
    <ElementLayout>
        <template #element>
            <!-- Customersite: MD / tax-defense stepper — secondary +/- buttons flanking a small centred input. -->
            <div v-if="showStepper" class="input-group number">
                <button type="button" class="btn btn-outline-secondary" tabindex="-1"
                        :disabled="atMin" aria-label="Decrease" @click="stepBy(-1)"><em class="far fa-chevron-down"></em></button>
                <input ref="input" type="tel" inputmode="numeric" class="form-control text-center"
                       :value="value ?? ''" :placeholder="placeholder"
                       @input="onInput" @blur="onBlur" />
                <button type="button" class="btn btn-outline-secondary" tabindex="-1"
                        :disabled="atMax" aria-label="Increase" @click="stepBy(1)"><em class="far fa-chevron-up"></em></button>
            </div>

            <!-- Backoffice: the same shared element with the stepper flag off — a plain number input. -->
            <div v-else class="vf-input-group">
                <input ref="input" type="number" class="vf-input-field"
                       :value="value ?? ''" :min="min ?? undefined" :max="max ?? undefined" :step="step"
                       :placeholder="placeholder" @input="onInput" @blur="onBlur" />
            </div>
        </template>

        <template v-for="(component, slot) in elementSlots" #[slot]>
            <slot :name="slot" :el$="el$">
                <component :is="component" :el$="el$" />
            </slot>
        </template>
    </ElementLayout>
</template>

<script>
import { defineElement } from '@vueform/vueform'
import { isCustomerSite } from '@/formEnvironment'
import { useNumberStepper } from './useNumberStepper'

export default defineElement({
    name: 'NumberStepperElement',

    props: {
        min: { type: Number, default: null },
        max: { type: Number, default: null },
        step: { type: Number, default: 1 },
        placeholder: { type: String, default: '' },
        // vueform doesn't auto-apply a schema `default` to a custom element's value, so take it here.
        default: { type: [Number, String], default: null },
    },

    setup(props, { element }) {
        const { value, atMin, atMax, stepBy, onInput, onBlur } = useNumberStepper(element, props)

        return {
            showStepper: isCustomerSite,
            value, min: props.min, max: props.max, step: props.step, placeholder: props.placeholder,
            atMin, atMax, stepBy, onInput, onBlur,
        }
    },
})
</script>
